import get from 'lodash/get';
import { getNewHitsetBySimilar } from '@Containers/FindPreparations/FindPreparationsHTTPService';
import UserDatabases from '@Services/UserDatabases';

export const SIMILARITY_ERRORS = {
  NOT_FOUND: 20,
  NOT_SUPPORTED: 21,
};

export const SIMILARITIES = [80, 60];

export const getResultSet = async ({ substance, databaseId }, similarityIndex = 0) => {
  if (!SIMILARITIES[similarityIndex]) {
    const defaultDatabaseId = UserDatabases.getDefaultDatabase().id;
    if (databaseId !== defaultDatabaseId) {
      return getResultSet({ substance, databaseId: defaultDatabaseId });
    }

    return Promise.reject();
  }

  try {
    return await getNewHitsetBySimilar(
      get(substance, 'molImage.structure'),
      databaseId,
      SIMILARITIES[similarityIndex],
      get(substance, 'details.id')
    );
  } catch (error) {
    if (error.errorNumber === SIMILARITY_ERRORS.NOT_FOUND) {
      return getResultSet({ substance, databaseId }, similarityIndex + 1);
    }
    return Promise.reject(error);
  }
};
